var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 16C5.3 10.2 10.3 6.75 16 6.75S26.7 10.2 29.5 16C26.7 21.8 21.7 25.25 16 25.25S5.3 21.8 2.5 16Z",
    stroke: "#66B927",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 5,
    stroke: "#66B927",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardViews);
export default __webpack_public_path__ + "static/media/dashboard_views.01300e99927d83374edf7437085d8bb8.svg";
export { ForwardRef as ReactComponent };